module.exports = __webpack_public_path__ + "img/data-2.fd9f8d98.png";